export const isSafari = /^((?!chrome|android).)*safari/i.test(
  navigator.userAgent
);

export const DATABASE_URL =
  "postgres://prryavsnhxcfyn:342a4e487de4db8920893347d2d2128f88ce1ac05be24a98558e6b2acbf64d16@ec2-3-222-74-92.compute-1.amazonaws.com:5432/d32evtfnsi5e51";

export const CONTACT_US_EMAIL = "ecclesia-global@proton.me";
